import PropTypes from 'prop-types';
import React from 'react';
import {Button} from 'semantic-ui-react';

import Table from '@appComponents/Table';
import ExcelExportButton from '@appComponents/ExcelExportButton';
import {hideModal} from '@utils/modal';
import {exportArgosStreamHistoryExcel} from '@modules/events/utils/export/argosStreamHistoryExcel';

import {streamHistoryColumns, streamHistoryRowRenderer} from '../../utils/argosHistoryTableHelper';

export const ArgosStreamHistoryModal = ({jobId, job}) => {
    const streamEvents = (job?.live_job?.stream?.events || []).map((entry, idx) => ({...entry, id: `${idx}-${entry.ts}-${entry.type}`}));

    return (
        <div className='argos-history-modal'>
            <span className='argos-history-modal__title'>{`Argos job ${jobId} - Stream history`}</span>
            <span className='argos-history-modal__divider-top'/>
            <div className='argos-history-modal__export'>
                <ExcelExportButton
                    exportExcelParams={exportArgosStreamHistoryExcel(jobId, streamEvents)}
                    loading={false}
                />
            </div>
            <Table
                name='argosStreamHistoryTable'
                columns={streamHistoryColumns}
                data={streamEvents}
                rowRenderer={streamHistoryRowRenderer}
                defaultSort='ts'
                defaultSortDirection='DESC'
                limit={50}
                size='small'
            />
            <span className='argos-history-modal__divider-bottom'/>
            <div className='argos-history-modal__close'>
                <Button
                    icon='remove'
                    content='Close'
                    onClick={hideModal}
                />
            </div>
        </div>
    );
};

ArgosStreamHistoryModal.propTypes = {
    jobId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    job: PropTypes.shape({
        id: PropTypes.string,
        live_job: PropTypes.shape({
            stream: PropTypes.shape({
                events: PropTypes.arrayOf(PropTypes.shape({
                    ts: PropTypes.string,
                    type: PropTypes.string,
                })),
            }),
        }),
    }),
};

ArgosStreamHistoryModal.defaultProps = {
    job: null,
};

export default ArgosStreamHistoryModal;
